// extracted by mini-css-extract-plugin
export default {"form_label":"form_label_form_label__nPHxb","form_label_required":"form_label_form_label_required__+65gq"};